module.exports = __webpack_public_path__ + "static/biscuit-acfa09debc694aec98e5b53081d35021.svg";